function build_my_own_init(ACS) {
  var bmo_wrapper = document.querySelector(".build-my-own___wrapper");
  if (!bmo_wrapper) return;

  const productCountInputs = document.querySelectorAll(".product_count_input");
  const placeholderWrappers = document.querySelectorAll(
    ".build-my-own__product_placeholder_wrapper",
  );
  const sectionHeader = bmo_wrapper.querySelectorAll(
    ".collections-wrapper .section-header .section-title",
  );
  const extraSlotWrapper = document.querySelector(".extra_product");
  const collectionsExtraWrapper = document.querySelectorAll(".collections-extra-wrapper");
  const addButtonsWrapper = document.querySelectorAll(".add-to-bundle-product");
  const addBundleToCartButtons = document.querySelectorAll(
    ".add-bundle-to-cart",
  );

  const collections = [...placeholderWrappers]
    .filter((w) => !w.classList.contains("extra_product"))
    .map((w) => w.dataset.collection);

  const collectionsName = [...placeholderWrappers]
    .filter((w) => !w.classList.contains("extra_product"))
    .map((w) => w.querySelector("h3").innerText);

  let selectedBundleSize = parseInt(
    document.querySelector(".product_count_input:checked").value,
    10,
  );

  let selectedProducts = {}; // slotIndex → productId

  const getExtraIndex = () => collections.length;
  const extraEnabled = () => selectedBundleSize === collections.length + 1;

  /** Update extra visibility */
  function updateExtraVisibility() {
    if (extraEnabled()) {
      extraSlotWrapper.style.display = "block";
      collectionsExtraWrapper.forEach((wrapper) => {
        wrapper.style.display = "block";
      });
    } else {
      extraSlotWrapper.style.display = "none";
      collectionsExtraWrapper.forEach((wrapper) => {
        wrapper.style.display = "none";
      });
      const extraIndex = getExtraIndex();

      if (selectedProducts[`product_${extraIndex}`]) {
        removeProductFromSlot(extraIndex);
      }
    }
  }

  /** make add bundle to cart enable disable **/

  function change_status_of_add_to_cart_button() {
    var status = false;
    if (Object.keys(selectedProducts).length == selectedBundleSize) {
      status = false;
    } else {
      status = true;
    }
    addBundleToCartButtons.forEach((button) => {
      button.disabled = status;
    });

    showWarningOneCollectionMissing();
    update_bundle_price();
  }

  function showWarningOneCollectionMissing() {
    var extraProductExist = false;
    var allBaseProductCount = 0;
    var extraIndex = getExtraIndex();
    var missingCollection = [];
    // show #d-warning-msg if
    for (c = 0; c < extraIndex; c++) {
      if (!selectedProducts[`product_${c}`]) {
        missingCollection.push(collectionsName[c]);
      } else {
        allBaseProductCount++;
      }
    }

    if (selectedProducts[`product_${extraIndex}`] && extraEnabled()) {
      extraProductExist = true;
    }

    if (allBaseProductCount === extraIndex - 1 && extraProductExist) {
      document.getElementById("d-warning-msg").innerHTML =
        "⚠️ Select one product from each core category to unlock 10% off. You need: " +
        missingCollection.join(", ");
      document.getElementById("d-warning-msg").style.display = "block";
    } else {
      document.getElementById("d-warning-msg").style.display = "none";
    }

    if (allBaseProductCount === extraIndex - 1 && extraEnabled()) {
      showAlert({
        type: "warning",
        title: "Almost There!",
        message: `Your 10% discount requires one product from each of the 4 core categories. You're still missing: ${missingCollection.join(", ")}.`,
      });
    } else if (allBaseProductCount === extraIndex - 1 && !extraEnabled()) {
      showAlert({
        type: "info",
        title: "One More to Go!",
        message: `Add a ${missingCollection[0]} to complete your core regimen and unlock 10% off!`,
      });
    } else if (allBaseProductCount === extraIndex && !extraEnabled()) {
      showAlert({
        type: "success",
        title: "10% Discount Unlocked!",
        message:
          "Great choice! Your 10% savings is now applied. Feel free to add a 5th product!",
      });
    } else if (
      allBaseProductCount === extraIndex &&
      extraEnabled() &&
      extraProductExist
    ) {
      showAlert({
        type: "success",
        title: "10% Discount Unlocked!",
        message:
          "Great choice! Your 10% savings is now applied. Feel free to add a 5th product!",
      });
    }
  }

  function update_bundle_price() {
    let total_price = 0;
    Object.values(selectedProducts).forEach(({ productId }) => {
      const button = document.querySelector(
        `.add-to-bundle[data-product="${productId}"]`,
      );
      if (button) {
        const price = parseFloat(button.dataset.price) || 0;
        total_price += price;
      }
    });
    const price_elem = document.querySelector(
      ".build-my-own__user_products_add_to_cart .add-bundle-to-cart",
    );
    const discount = 0.1; // 10% discount
    const old_price = total_price;
    const new_price = total_price * (1 - discount);
    if (total_price > 0) {
      price_elem.innerHTML = `ADD REGIMEN TO BAG: <span class="old_price">${ACS.formatMoney(old_price * 100)}</span> <span class="new_price">${ACS.formatMoney(new_price * 100)}</span>`;
    } else {
      price_elem.textContent = `ADD REGIMEN TO BAG`;
    }
  }

  /** Find collection slot index by handle */
  function getCollectionSlotIndex(handle) {
    return collections.indexOf(handle);
  }

  /** Apply product to a slot */
  function applyToSlot(slotIndex, productId, collection, img, title, button) {
    selectedProducts[`product_${slotIndex}`] = {
      collection,
      productId,
    };

    const slotWrapper = placeholderWrappers[slotIndex];
    const slot = slotWrapper.querySelector(
      ".build-my-own__product_placeholder",
    );

    slot.innerHTML = `
      <img src="${img}" alt="${title}" class="selected-product-img">
      <button class="remove-selected" data-slot="${slotIndex}">×</button>
        `;

    button.textContent = "✓ ADDED";
    button.classList.add("in-bundle");
    slot.classList.add("filled");
    slot.classList.remove("focused");
    slot.querySelector(".remove-selected").addEventListener("click", () => {
      removeProductFromSlot(slotIndex);
    });
    change_status_of_add_to_cart_button();

    const nextCollection = getNextEmptyCollection();
    scrollToCategory(nextCollection);
    scrollToNextEmptyCollection();
  }

  /** Remove a product from a slot */
  function removeProductFromSlot(slotIndex) {
    const { productId } = selectedProducts[`product_${slotIndex}`];

    if (!productId) return;

    // reset UI
    const slot = placeholderWrappers[slotIndex].querySelector(
      ".build-my-own__product_placeholder",
    );
    slot.classList.add("focused");
    slot.classList.remove("filled");
    slot.innerHTML = "";

    // reset button
    const btn = document.querySelector(
      `.add-to-bundle.in-bundle[data-product="${productId}"]`,
    );
    if (btn) {
      btn.textContent = "ADD TO REGIMEN";
      btn.classList.remove("in-bundle");
    }

    delete selectedProducts[`product_${slotIndex}`];

    const extraIndex = getExtraIndex();
    change_status_of_add_to_cart_button();
    // ------------------------------
    // CASE 1: Bundle TYPE changed from X+1 → X
    // (meaning extra slot disabled)
    // ------------------------------
    // if (!extraEnabled()) {
    //   // If we removed a collection slot, do NOT move from old extra
    //   // Just keep everything as-is; extra product is already removed in updateExtraVisibility()
    //   change_status_of_add_to_cart_button();
    //   return;
    // }

    // ------------------------------
    // CASE 2: We removed FROM EXTRA
    // ------------------------------
    // if (slotIndex === extraIndex) {
    //   // Nothing to shift into EXTRA → just leave empty
    //   change_status_of_add_to_cart_button();
    //   return;
    // }

    // ------------------------------
    // CASE 3: Extra is enabled, and we removed a COLLECTION slot
    // Move extra product → empty collection slot
    // ------------------------------
    // const extraProduct = selectedProducts[`product_${extraIndex}`];
    // if (!extraProduct) return; // no extra to shift
    // const extraProductId = extraProduct.productId;
    // const extraCollection = extraProduct.collection;
    // if(extraCollection!==collection)return;

    // const extraBtn = document.querySelector(
    //   `.add-to-bundle[data-product="${extraProductId}"]`
    // );

    // // data to reapply
    // const img = extraBtn.parentElement.parentElement.querySelector("img").src;
    // const title = extraBtn.parentElement.querySelector("h4").innerText;

    // // Remove from extra
    // removeProductFromSlot(extraIndex);

    // // Apply to the newly emptied collection slot
    // applyToSlot(slotIndex, extraProductId,collection, img, title, extraBtn);
    // change_status_of_add_to_cart_button();
  }

  /** Handle product click */
  function addProductToSlot(wrapper) {
    const button = wrapper.querySelector(".add-to-bundle");
    const productId = button.dataset.product;
    const productImg =
      button.parentElement.parentElement.querySelector("img").src;
    const productTitle = button.parentElement.querySelector("h4").innerText;
    const collection = button.dataset.collection;
    // Determine collection slot
    const colIndex = getCollectionSlotIndex(collection);
    console.log("colIndex",colIndex)

    // If already selected → remove from whatever slot it's in
    if (button.classList.contains("in-bundle")) {
      const slotIndex = Object.keys(selectedProducts).find(
        (key) => selectedProducts[key].productId == productId,
      );
      removeProductFromSlot(parseInt(slotIndex.replace("product_", ""), 10));
      return;
    }

    if (selectedProducts[`product_${colIndex}`] && !extraEnabled()) {
      removeProductFromSlot(parseInt(colIndex, 10));
    }
    // 1️⃣ If collection slot EMPTY → fill collection slot
    if (!selectedProducts[`product_${colIndex}`] && colIndex != -1) {
      applyToSlot(
        colIndex,
        productId,
        collection,
        productImg,
        productTitle,
        button,
      );
      return;
    }

    // 2️⃣ If collection slot FULL → replace that slot
    if (!extraEnabled()) {
      applyToSlot(
        colIndex,
        productId,
        collection,
        productImg,
        productTitle,
        button,
      );
      return;
    }

    // 3️⃣ EXTRA ENABLED → use extra slot
    const extraIndex = getExtraIndex();

    // If extra has product → replace it
    if (selectedProducts[`product_${extraIndex}`]) {
      removeProductFromSlot(extraIndex);
    }

    applyToSlot(
      extraIndex,
      productId,
      collection,
      productImg,
      productTitle,
      button,
    );
  }

  /** Attach events */
  addButtonsWrapper.forEach((wrapper) => {
    wrapper.addEventListener("click", function () {
      addProductToSlot(this);
    });
  });

  function scrollToCategory(categoryId) {
    if (!categoryId) return;
    focusedCategory = categoryId;
    const element = document.querySelector(
      ".collections-wrapper.collection-" + categoryId,
    );
    if (element) {
      const mobile = window.innerWidth <= 1199;
      const headerHeight = document.querySelector(".build-my-own").offsetHeight;
      const vsc_header_wrap = mobile
        ? 0
        : document.querySelector(".full-width.vsc_header_wrap").offsetHeight;
      const elementPosition =
        element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - headerHeight - vsc_header_wrap,
        behavior: "smooth",
      });
    }
  }

  function scrollToNextEmptyCollection() {
    const container = document.querySelector(".build-my-own__user_products");
    if (!container) return;

    // Only run if horizontal scroll exists
    if (container.scrollWidth <= container.clientWidth) return;

    const items = Array.from(
      container.querySelectorAll(".build-my-own__product_placeholder_wrapper"),
    ).filter((el) => el.offsetParent !== null); // only visible ones

    // Find next empty (including extra if visible)
    for (let i = 0; i < items.length; i++) {
      const placeholder = items[i].querySelector(
        ".build-my-own__product_placeholder",
      );

      if (!placeholder.classList.contains("filled")) {
        container.scrollTo({
          left: items[i].offsetLeft - container.offsetLeft,
          behavior: "smooth",
        });
        break;
      }
    }
  }

  function getNextEmptyCollection() {
    for (let i = 0; i < collections.length; i++) {
      const handle = collections[i];
      if (
        !selectedProducts["product_" + i] ||
        selectedProducts["product_" + i].collection != handle
      ) {
        return handle;
      }
    }
    return null; // all filled
  }

  $(document).on(
    "click",
    ".build-my-own__product_placeholder.focused",
    function () {
      const collection = $(this)
        .closest(".build-my-own__product_placeholder_wrapper")
        .data("collection");
      scrollToCategory(collection);
    },
  );

  productCountInputs.forEach((input) => {
    input.addEventListener("change", function () {
      selectedBundleSize = parseInt(this.value, 10);
      updateExtraVisibility();
      change_status_of_add_to_cart_button();
    });
  });

  addBundleToCartButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      // Collect selected variants
      const items = Object.values(selectedProducts).map((variant) => ({
        id: variant.productId,
        quantity: 1,
      }));

      if (!items.length) {
        alert("Please select products before adding to cart.");
        return;
      }

      // Disable button during request
      btn.disabled = true;
      btn.classList.add("disabled");

      // Send AJAX request (ACS compatible)
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: JSON.stringify({ items }),
        dataType: "json",
        contentType: "application/json",
        success: function () {
          btn.disabled = false;
          btn.classList.remove("disabled");

          // Update badge + open ACS cart drawer
          ACS.updateCartBadge();
          ACS.fetchCart(true);
        },
        error: function (xhr) {
          btn.disabled = false;
          btn.classList.remove("disabled");

          var message = "Unable to add bundle to cart.";

          try {
            var json = JSON.parse(xhr.responseText);
            if (json && (json.description || json.message)) {
              message = json.description || json.message;
            }
          } catch (e) {}

          $(".acs-cart-error").text(message).fadeIn(200);
          setTimeout(() => $(".acs-cart-error").fadeOut(200), 4000);
        },
      });
    });
  });

  updateExtraVisibility();

  const checkboxes = document.querySelectorAll(
    '.filter-option input[type="checkbox"]',
  );

  document.addEventListener("change", function (e) {
    const form = e.target.closest(".horizontal-facet-filter-bar form");
    if (!form) return;
    e.preventDefault();
    filterProducts();
  });
  const products = document.querySelectorAll(".collection-product");
  const products_swiper = document.querySelectorAll(
    ".build_my_own__products_swiper",
  );

  function filterProducts() {
    // Get all checked values
    const activeFilters = Array.from(checkboxes)
      .filter((cb) => cb.checked)
      .map((cb) => cb.value);
    products.forEach((product) => {
      // If no filters selected → show all
      if (activeFilters.length === 0) {
        product.style.display = "";
        return;
      }

      // Check if product has ANY matching class
      // OR condition
      const matches = activeFilters.some((filter) =>
        product.classList.contains(filter),
      );
      // AND condition
      // const matches = activeFilters.every((filter) => product.classList.contains(filter));

      product.style.display = matches ? "" : "none";
    });

    products_swiper.forEach((swiper) => {
      if (swiper.swiper) {
        swiper.swiper.update();
      }
    });
  }

  // Listen for checkbox changes
  document.addEventListener("click", function (e) {
    const removeBtn = e.target.closest(".active-filter-chip");
    if (!removeBtn) return;

    const value = e.target.dataset.filter;
    const form = e.target.closest(".horizontal-facet-filter-bar form");
    if (!form) return;

    // Uncheck checkbox(s) matching value
    form
      .querySelectorAll(`input[value="${value}"]`)
      .forEach((cb) => (cb.checked = false));

    // Animate chip removal
    const chip = removeBtn.closest(".active-filter-chip");
    if (chip) {
      chip.style.transition = "all 0.3s ease";
      chip.style.opacity = 0;
      chip.style.transform = "scale(0.9)";
      setTimeout(() => chip.remove(), 300);
    }

    form.dispatchEvent(new Event("change", { bubbles: true }));
  });

  function showAlert({ type = "info", title = "", message = "" }) {
    function removeAlert(alertDiv) {
      if (!alertDiv) return;
      alertDiv.classList.remove("show");
      setTimeout(() => {
        alertDiv.remove();
      }, 500);
    }

    function showAlert(alertDiv) {
      if (!alertDiv) return;
      setTimeout(() => {
        alertDiv.classList.add("show");
      }, 100);
    }
    // remove existing alert if any
    const existing = document.getElementById("custom-alert");
    removeAlert(existing);

    const colors = {
      warning: { bg: "#fff3e0", border: "#ff9800", icon: "⚠️" },
      success: { bg: "#e8f5e9", border: "#4caf50", icon: "✓" },
      info: { bg: "#e3f2fd", border: "#2196f3", icon: "ℹ️" },
    };

    const { bg, border, icon } = colors[type] || colors.info;

    const alertDiv = document.createElement("div");
    alertDiv.id = "custom-alert";
    alertDiv.classList.add("alert");
    alertDiv.classList.add(type);
    alertDiv.style.cssText = `
        background: ${bg};
        border-left: 4px solid ${border};
      `;

    alertDiv.innerHTML = `
          <div class="alert-header">
            <div>
              <div class="alert-title" >${title}</div>
              <div class="alert-message" >${message}</div>
            </div>
            <button class="alert-close">×</button>
          </div>
      `;

    document.body.appendChild(alertDiv);
    showAlert(alertDiv);

    // close button
    alertDiv.querySelector(".alert-close").onclick = () => {
      removeAlert(alertDiv);
    };

    // auto dismiss after 5s (optional)
    setTimeout(() => {
      removeAlert(alertDiv);
    }, 5000);
  }
}
